import { usePipPlayerStore } from '@/stores/pip-player.store';
import { useEventPlaybackData } from '../hooks/useEventPlaybackData';
import { PipPlayer } from '../PipPlayer';
import { PipLoadingState } from './PipLoadingState';

export function PipEventContent() {
    const mode = usePipPlayerStore((s) => s.mode);
    const eventId = usePipPlayerStore((s) => s.eventId);
    const {
        event,
        source,
        confidence,
        focuses,
        startTime,
        eventRange,
        isLoading,
    } = useEventPlaybackData(eventId, mode);

    if (isLoading || !event || !source) {
        return <PipLoadingState />;
    }

    return (
        <PipPlayer
            event={event}
            source={source}
            confidence={confidence}
            focuses={focuses}
            startTime={startTime}
            eventRange={eventRange}
        />
    );
}
